import React from 'react';
import Header from './Header';
import Footer from './Footer';
import LiveStreamBanner from './LiveStreamBanner';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="layout">
      <div className="site-header">
        <Header />
        <LiveStreamBanner />
      </div>
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;

